module.exports = __webpack_public_path__ + "img/web_01_3.b8d544b3.jpg";